module.exports = __webpack_public_path__ + "img/cat-pizza.b038c2d2.webp";